
<div
  :class="
    classes(
      n(),
      n(`--${size}`),
      n(`--${variant}`),
      n(`--${color}`)
    )
  "
  :style="style"
>
  <div :class="n('content')">
    <i
      v-if="icon"
      :class="n('icon')"
    >
      <component :is="icon" />
    </i>
    <span>{{ content }}</span>
  </div>
</div>
